angular
  .module('surfsightApp.controllers')

  .controller('edgeReportsController', [
    '$scope',
    '$rootScope',
    '$log',
    '$state',
    '$timeout',
    '$interval',
    '$location',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdMedia',
    '$mdSidenav',
    '$mdToast',
    '$mdColors',
    'edgeFactory',
    'edgeGroupFactory',
    'leafletData',
    'nominatimLookUp',
    '$stateParams',
    function (
      $scope,
      $rootScope,
      $log,
      $state,
      $timeout,
      $interval,
      $location,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdMedia,
      $mdSidenav,
      $mdToast,
      $mdColors,
      edgeFactory,
      edgeGroupFactory,
      leafletData,
      nominatimLookUp,
      $stateParams
    ) {
      const deviceId = parseInt($stateParams.edge_id)
      const groupId = parseInt($stateParams.edge_group_id)
      $scope.edge_name = 'Devices'
      $scope.edgeGroupDetails = ''
      const stateName = $state.current.name
      $scope.reportsList = angular.copy(window.reportsList)
      if (stateName === 'home.common.reports.edge') {
        let [edge] = edgeFactory.list.filter(e => e.id === deviceId)
        if (edge) {
          $scope.edge = edge
          $scope.edge_name = $scope.edge.name
        } else {
          $scope.$emit('LOAD_DEVICE_DETAILS_REQUEST', { id: deviceId })
          $scope.$on('LOAD_DEVICE_DETAILS_SUCCESS', function (e, data) {
            if (data.id === deviceId) {
              ;[edge] = edgeFactory.list.filter(e => e.id === deviceId)
              $scope.edge = edge
              $scope.edge_name = $scope.edge.name
            }
          })
        }
      } else if (stateName === 'home.common.reports.edgegroup') {
        if (groupId === -1) {
          $scope.edge_name = 'Devices'
        } else {
          let [group] = edgeGroupFactory.list.filter(e => e.id === groupId)
          if (group) {
            $scope.edgeGroupDetails = group
            $scope.edge_name = group.name
          } else {
            $scope.$emit('LOAD_GROUP_DETAILS_REQUEST', { id: groupId })
            $scope.$on('LOAD_GROUP_DETAILS_SUCCESS', function (e, data) {
              if (data.id === groupId) {
                ;[group] = edgeGroupFactory.list.filter(e => e.id === groupId)
                $scope.edgeGroupDetails = group
                $scope.edge_name = $scope.edgeGroupDetails.name
              }
            })
          }
        }
      }
      $scope.showReportDashboard = function (report) {
        if (!$mdMedia('gt-sm')) {
          if (stateName === 'home.common.reports.edge') {
            $state.go('home.common.reports.edgereportDashboard', {
              edge_id: deviceId,
              eventSearch: $rootScope.reportDateRangeFilter,
              reportType: report.id
            })
          } else if (stateName === 'home.common.reports.edgegroup') {
            $state.go('home.common.reports.edgegroupreportDashboard', {
              edge_group_id: groupId,
              eventSearch: $rootScope.reportDateRangeFilter,
              reportType: report.id
            })
          }
        } else {
          $scope.$emit('reportType', { type: report.id })
        }
      }
      if (!$rootScope.reportDateRangeFilter) {
        $rootScope.reportDateRangeFilter = $stateParams.eventSearch
      }
      if (!$rootScope.reportDateRangeFilter) {
        $rootScope.reportDateRangeFilter = {
          id: 1,
          name: Date.today().toString('dddd, dd MMM yyyy'),
          name_formate1: 'today',
          name_formate2: Date.today().toString('MMM dd '),
          current_year: Date.today().toString('yyyy'),
          date: {
            // start: 0,
            start: Date.today().getTime(),
            end: Date.today()
              .add(1)
              .day()
              .getTime()
          }
        }
      }
      $scope.eventSearch = $rootScope.reportDateRangeFilter
      $scope.$on('SHOW_REPORT_DATE_FILTER_REQUEST', (e, data) => {
        $scope.showReportDateFilter(data.event)
      })
      $scope.showReportDateFilter = function (ev) {
        $mdDialog
          .show({
            controller: 'EdgeReportDateFilter',
            // controller: function(){},
            templateUrl:
              './templates/edge.report.date.filter.view.html?t=' +
              window.webpackHash,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(
            function (response) {
              $rootScope.reportDateRangeFilter = response
              $scope.eventSearch = $rootScope.reportDateRangeFilter
              $scope.filterActivated = false
              $scope.$emit('eventSearchData', { response })
            },
            function () {
              //
            }
          )
      }

      function loadData () {
        $scope.eventsSidenav = false
        $scope.disabledValue = false
        $scope.edge_event_history_loading = true
        $scope.edge_events_array = []
        if (!$rootScope.reportDateRangeFilter) {
          $rootScope.reportDateRangeFilter = {
            id: 1,
            name: Date.today().toString('dddd, dd MMM yyyy'),
            name_formate1: 'today',
            name_formate2: Date.today().toString('MMM dd '),
            current_year: Date.today().toString('yyyy'),
            date: {
              // start: 0,
              start: Date.today().getTime(),
              end: Date.today()
                .add(1)
                .day()
                .getTime()
            }
          }
          $scope.eventSearch = $rootScope.reportDateRangeFilter
        }
      }
      loadData()
      $scope.hideEventsSidenav = function () {
        $state.go('home.common.reports')
      }
      $scope.$on('showReportTableReceive', function (e, data) {
        $rootScope.reportDateRangeFilter = data.eventSearch
        $scope.eventSearch = $rootScope.reportDateRangeFilter
      })
    }
  ])
